// Ícone SVG inline da bandeira Visa (sem requisição HTTP)
import * as React from 'react';

export function VisaIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Visa" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <text
        x="24"
        y="21"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="900"
        fontStyle="italic"
        fontSize="12"
        fill="#1A1F71"
        letterSpacing="0.5"
      >
        VISA
      </text>
      <rect x="10" y="23" width="28" height="2" fill="#F7B600" />
    </svg>
  );
}
